import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { CPFMaskedInput } from "../../../../../../common/components/masked_inputs/cpf_masked_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { CNPJMaskedInput } from "../../../../../../common/components/masked_inputs/cnpj_masked_input";

/**
 * Header ContasReceber Lista.
 * 
 */

type Props = {
  ddlCentroCusto: DropDown[];
  selectedIdsCentroCusto?: number[];
  nomeFantasia?: string;
  cnpj?: string;
  cpf?: string;
  unidade?: string;

  onClearFilters: () => void;
  handleIdsCentroCustoChange: (v: number[]) => void;
  handleNomeFantasiaChange: (novoNome: string | null) => void;
  handleCnpjChange: (novoCnpj: string | null) => void;
  handleCpfChange: (novoCpf: string | null) => void;
  handleUnidadeChange: (novaUnidade: string | null) => void;
};


export const Header = ({
  ddlCentroCusto,
  selectedIdsCentroCusto,
  nomeFantasia,
  cnpj,
  cpf,
  unidade,
  onClearFilters,
  handleNomeFantasiaChange,
  handleIdsCentroCustoChange,
  handleCnpjChange,
  handleCpfChange,
  handleUnidadeChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultInput
                  name='nomeFantasia'
                  label='Nome'
                  value={nomeFantasia}
                  onChangeValue={handleNomeFantasiaChange}
                />
              </div>

              <div className="w-full">
                <CNPJMaskedInput
                  name='cnpj'
                  label='Cnpj'
                  value={cnpj}
                  unmask={true}
                  onChange={handleCnpjChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-3 lg:col-span-3 gap-1 " >

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='unidade'
                  label='Unidade do Centro de Custo Principal'
                  value={unidade}
                  onChangeValue={handleUnidadeChange}
                />
              </div>

              <div className="w-full">
                <CPFMaskedInput
                  name='cpf'
                  label='CPF'
                  value={cpf}
                  unmask={true}
                  onChange={handleCpfChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}